import { addressDef } from "./address-def";

export const temporaryAddressDialogDef = {
  type: "temporaryAddress",
  dialogLabel: "MY_HR_EDIT_TEMPORARY_ADDRESS",
  ...addressDef(),
};
